// extracted by mini-css-extract-plugin
export default {"leftCOntent":"header_leftCOntent__XdJ4f","headerHidden":"header_headerHidden__764Jy","headerVisible":"header_headerVisible__988gI","logo":"header_logo__wLirW"};